export default __webpack_public_path__ + "static/media/free-icon.12e53f2f.svg";